import axios from 'axios'
import {
	MessageBox,
	Message
} from 'element-ui'
import {
	getToken,
	removeToken
} from '@/utils/auth'

const service = axios.create({
	baseURL: '/api',
	timeout: 15000
})

// 请求拦截器
service.interceptors.request.use(
	config => {
		const token = getToken()
		if (token) {
			config.headers['Authorization'] = 'Bearer ' + token
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应拦截器
service.interceptors.response.use(
	response => {
		const res = response.data

		// 二进制文件下载（blob）直接放行，不走 code 校验
		if (response.config.responseType === 'blob') {
			return response
		}

		if (res.code === 401) {
			MessageBox.confirm('登录状态已过期，请重新登录', '系统提示', {
				confirmButtonText: '重新登录',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				removeToken()
				location.reload()
			})
			return Promise.reject(new Error(res.message || 'Error'))
		}

		if (res.code !== 200) {
			Message({
				message: res.message || '请求失败',
				type: 'error',
				duration: 5000
			})
			return Promise.reject(new Error(res.message || 'Error'))
		}

		return res
	},
	error => {
		Message({
			message: error.message || '网络异常',
			type: 'error',
			duration: 5000
		})
		return Promise.reject(error)
	}
)

export default service